<script setup lang="ts">
// Bordered card primitive for completion views. Content is slot-driven so
// each view composes its own rows, dividers, and badges.
//
// Pair with `CompletionSummaryRow` conceptually, but rows are plain markup
// inside the slot to keep the primitive simple — no need for a dedicated
// row component until we find three+ views duplicating the same row shape.

defineProps<{
    heading?: string;
}>();
</script>

<template>
    <section class="csc">
        <h3 v-if="heading" class="csc__heading">{{ heading }}</h3>
        <div class="csc__card">
            <slot />
        </div>
    </section>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.csc {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &__heading {
        font-size: $text-portal-body-lg;
        font-weight: 700;
        color: $portal-text;
        margin: 0;
    }

    &__card {
        border: 1px solid $portal-border;
        border-radius: $portal-card-radius;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
}
</style>
